<!-- Localized -->
<template>
    <div class="print-d-block tw-flex tw-flex-col tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-overflow-x-hidden">
        <!-- {{expandedCard.sources}} -->
        <div @click="handleExpandAll" class="print-hidden tw-text-blue-600 tw-ml-auto tw-cursor-pointer hover:tw-text-blue-400 tw-inline-flex">
            <template v-if="!adverseCard.expandedPanel">Expand All</template>
            <template v-else>Collapse All</template>
        </div>

        <div>
            <div v-if="screeningListData">
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'screening')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-2 tw-justify-between tw-border tw-border-solid tw-border-blue-200 rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Screening List</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.screeningExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-show="adverseCard.screeningExpanded">
                    <div class="tw-mt-2">
                        <div class="tw-mb-2 tw-flex tw-space-x-2" :identifier="`['data']['NameSource']`">
                            <div class="tw-w-1/3 lg:w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400">Source</div>
                            <div class="tw-w-full tw-p-2">
                                <div class="tw-flex tw-justify-between tw-items-center">
                                    <span class="tw-space-y-2 tw-mb-2 tw-font-medium">
                                        <template> {{ adverseCard.NameSource }}</template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="tw-mb-2 tw-flex tw-space-x-2" :identifier="`['data']['ExpirationDate']`">
                            <div class="tw-w-1/3 lg:tw-w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400">Record Expiration Date:</div>
                            <div class="tw-w-full tw-p-2">
                                <div class="tw-flex tw-justify-between tw-items-center">
                                    <span class="tw-space-y-2 tw-mb-2 tw-font-medium">
                                        <template v-if="adverseCard && adverseCard.ExpirationDate"> {{ adverseCard.ExpirationDate }}</template>
                                        <template v-else> - </template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="tw-mb-2 tw-flex tw-space-x-2" :identifier="`['data']['File']['EffectiveDate']`">
                            <div class="tw-w-1/3 lg:tw-w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400">Record Effective Date:</div>
                            <div class="tw-w-full tw-p-2">
                                <div class="tw-flex tw-justify-between tw-items-center">
                                    <span class="tw-space-y-2 tw-mb-2">
                                        <template v-if="adverseCard && adverseCard.EffectiveDate"> {{ adverseCard.EffectiveDate }}</template>
                                        <template v-else> - </template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Screening List</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.screeningExpanded"></div>
            </div>
        </div>

        <!-- Relationship section -->
        <div v-if="get(adverseCard.data, 'Relationships', []).length > 0">
            <template>
                <div
                    ref="refAliases"
                    @click="fetchMoreInfo(adverseCard, 'relationship')"
                    class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-2 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md"
                >
                    <div class="tw-text-lg tw-font-medium">Relationships</div>
                    <div>
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand"
                        :class="{ 'tw-rotate-180': adverseCard.relationshipExpanded }"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                        />
                        </svg>
                    </div>
                </div>
                <div
                    class="tw-p-2 headingBlock-sibling"
                    v-show="adverseCard.relationshipExpanded"
                >
                <div class="tw-shadow tw-rounded tw-border tw-border-solid tw-border-gray-300 tw-overflow-x-auto">
                    <table
                    id="principals"
                    class="principalsTable tw-w-full tw-divide-y tw-divide-gray-200"
                    >
                    <thead class="tw-bg-gray-50 tw-sticky tw-top-0">
                        <tr>
                        <th
                            scope="col"
                            class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider"
                        >
                            Entity Name
                        </th>
                        <th
                            scope="col"
                            class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider"
                        >
                            Relationship Group
                        </th>
                        <th
                            scope="col"
                            class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider"
                        >
                            Type
                        </th>
                        <th
                            scope="col"
                            class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider"
                        >
                            Ownership Percentage
                        </th>
                        <th
                            scope="col"
                            class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider"
                        >
                            Segment
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(relation,index) in adverseCard.data.Relationships" :key="index" :class="{'tw-bg-gray-100': index % 2 === 0, 'tw-bg-white': index % 2 !== 0}"
                        :identifier="`
                            ['data']['Relationships'][${index}]['EntityName']
                            ['data']['Relationships'][${index}]['Group'] 
                            ['data']['Relationships'][${index}]['Type'] 
                            ['data']['Relationships'][${index}]['OwnershipPercentage'] 
                            ['data']['Relationships'][${index}]['Segments'] 
                        `">
                            <td class="tw-px-6 tw-py-2 tw-text-sm tw-text-gray-500 tw-break-words">{{relation.EntityName}}</td>
                            <td class="tw-px-6 tw-py-2 tw-text-sm tw-text-gray-500 tw-break-words">{{relation.Group}}</td>
                            <td class="tw-px-6 tw-py-2 tw-text-sm tw-text-gray-500 tw-break-words">{{relation.Type}}</td>
                            <td class="tw-px-6 tw-py-2 tw-text-sm tw-text-gray-500 tw-break-words">{{relation.OwnershipPercentage}}</td>
                            <td class="tw-px-6 tw-py-2 tw-text-sm tw-text-gray-500 tw-break-words">{{relation.Segments}}</td>
                        </tr>

                    </tbody>
                    
                    </table>
                </div>
                </div>
            </template>
        </div>

        <!-- Additional information -->
        <div>
            <template>
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'otherinfo')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-2 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Additional Information</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.otherinfoExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 tw-flex-col  headingBlock-sibling" v-show="adverseCard.otherinfoExpanded">
                    <div class="tw-mt-2">
                        <div class="tw-mb-2 tw-gap-3 tw-space-x-2">
                            <div class="tw-w-full tw-p-2">
                                <div class="tw-grid tw-col-2" v-for="[data, value] in Object.entries(additionalInformation)" :key="data">
                                    <div class="tw-flex tw-gap-2 tw-mt-2.5" v-if="data !== 'relationships'" :identifier="getAdditionalIden(data)">
                                        <span class="tw-text-s tw-text-gray-500 tw-w-1/3 lg:tw-w-1/4 tw-capitalize"> {{ data.replaceAll("_", " ") }} :</span>
                                        <span class="tw-text-m tw-font-medium tw-w-full" v-if="data!='profile_notes' || !editFields"> {{value}} </span>
                                        <textarea v-else
                                            :style="{
                                                height: 'calc(100% - 0.2rem)',
                                                width: '100%',
                                                'background-color': 'white'
                                            }"
                                            class="tw-resize-y tw-rounded-xl tw-px-4 tw-py-2 tw-border-2"
                                            rows="10"
                                            placeholder=""
                                            v-model="getProfileNotes"
                                        >
                                        </textarea>
                                    </div>
                                    <div v-else>
                                        <div class="tw-flex tw-gap-2 tw-mt-2.5">
                                            <span class="tw-text-s tw-text-gray-500 tw-w-1/3 lg:tw-w-1/4 tw-capitalize">{{ data.replaceAll("_", " ") }}:</span>
                                            <span class="tw-text-m tw-font-medium tw-w-full">{{value}}</span>
                                        </div>
                                        <div class="tw-w-full lg:tw-h-3/4 tw-mt-2.5" v-if="value=='Yes'">
                                            <div class="print-overflow-table tw-flex tw-justify-between tw-items-center tw-overflow-x-auto scroll INFORMATION_PROVIDER">
                                                <table class="min-w-full divide-y divide-gray-200 border border-solid border-gray-300">
                                                    <thead class="bg-gray-50" >
                                                        <tr>
                                                            <th scope="col" class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">
                                                                Name
                                                            </th>
                                                            <th scope="col" class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">
                                                                Relation Type
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="tw-bg-white tw-divide-y tw-divide-gray-200">
                                                        <tr v-for="(res, ri) in adverseCard.Relations" :key="ri">
                                                        <td class="tw-px-6 tw-py-4 whitespace-nowrap">
                                                            <div :identifier="`['data']['Relations'][${ri}]['Name']`">
                                                            {{ getFormattedName(res.Name) }}
                                                            </div>
                                                        </td>
                                                        <td class="tw-px-6 tw-py-4 whitespace-nowrap">
                                                            <div :identifier="`['data']['Relations'][${ri}]['RelationDef']`">
                                                            {{ res.Type.RelationDef }}
                                                            </div>
                                                        </td>
                                                        </tr>
                                                    </tbody>
                                                    <!-- <tbody class="bg-white divide-y divide-gray-200" v-else>
                                                        <tr>
                                                            <td colspan="2" class="py-2 tw-text-center">No data available</td>
                                                        </tr>
                                                    </tbody> -->
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- Record sources --> 
        <div>
            <template v-if="sourceLinks.length > 0 || editFields">
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'sources')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-2 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Record Sources</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.sourcesExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-show="adverseCard.sourcesExpanded">
                    <div class="tw-mt-2">
                        <div class="tw-mb-2 tw-flex tw-space-x-2" :identifier="`['adverseCard']['data']['EntityDetails']['AdditionalInfo']`">
                            <div class="tw-w-full tw-p-2">
                                <div v-if="sourceLinks.length > 0 || editFields">
                                    <template v-if="!editFields">
                                        <div class="tw-flex tw-justify-between tw-items-center" v-for="dataSource in SourceWebLink" :key="dataSource">
                                            <div class="tw-space-y-2">
                                                <div class="tw-flex tw-justify-between tw-items-center"  :identifier="`['data']['SourceWebLink']`">
                                                    <span class="tw-space-y-2 tw-mb-2">
                                                        <a :href="dataSource" class="tw-text-blue-600 hover:tw-text-blue-900 tw-no-underline" target="_blank">
                                                            <span class="tw-break-words"> {{ dataSource }} </span>
                                                        </a>
                                                        <!-- <template><a>{{ data1 }}</a></template> -->
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    
                                    <textarea v-else
                                        :style="{
                                            height: 'calc(100% - 0.2rem)',
                                            width: '100%',
                                            'background-color': 'white'
                                        }"
                                        class="resize-y rounded-xl px-4 py-2 border-2"
                                        rows="10"
                                        placeholder="Record Sources"
                                        v-model="sourceLinks"
                                    >
                                    </textarea>
                                </div>
                                <div v-else>
                                    <div class="tw-flex tw-justify-between tw-items-center" v-for="(data, index) in get(adverseCard, 'data.EntityDetails.AdditionalInfo', [])" :key="index"
                                    :identifier="`['data']['EntityDetails']['AdditionalInfo'][${index}]['Comments']`">
                                        <div class="tw-space-y-2" v-if="data.Type === 'Other' && data.Value === 'Sources of Record Information' && data.Comments">
                                            <div class="tw-flex tw-justify-between tw-items-center" v-for="(data1, index) in data.Comments.split('|')" :key="index">
                                                <span class="tw-space-y-2 tw-mb-2">
                                                    <a :href="data1" class="tw-text-blue-600 hover:tw-text-blue-900 tw-no-underline" target="_blank">
                                                        <span class="tw-break-words"> {{ data1 }} </span>
                                                    </a>
                                                    <!-- <template><a>{{ data1 }}</a></template> -->
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Record Sources</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.sourcesExpanded"></div>
            </template>
        </div>
    </div>
</template>
<script>
// import { DateTime } from "luxon";
import {get} from "lodash";
import {DateTime} from "luxon";
import adverseMixin from "@/mixins/adverseMixin";
import printDataMixin from "@/mixins/printDataMixin";
import highlighterMixin from "@/mixins/highlighterMixin";

export default {
    components: {
    },
    data() {
        return {
            selected: "Enforcements",
            // TODO translate if will be used
            segmentsTabs: ["Enforcements", "SOE", "Adverse Media"],
            urlFields: ["related url", "locationurl"],
            isPrintLoader: false,
            refBtnClick: {
                advDetails: true,
                advAssociates: true,
                advPEP: true,
                advPepClass: true,
                advFitness: true,
                advImages: true,
                advAdverseMedia: true,
                advMediaData: true,
                refNameSection: true,
                refcontryTerritoryDetails: true,
                refDatesSection: true,
                refAddressSection: true,
                refImagesSection: true,
                refRolesSection: true,
                refRelativeCloseDowjonesSection: true,
                refProfileNotesDowjonesSection: true,
                refSourceSection: true,
                refworldcheck: true,
                refAliases: true,
                refCitizenships: true,
                refLocations: true,
                refFurtherInfo: true,
                refInformationSources: true,
            },
            printDone: false,
        };
    },
    mixins: [adverseMixin, printDataMixin, highlighterMixin],
    props: {
        expandedCard: {
            type: Object,
        },
        isResultExpanded: {
            type: Boolean,
        },
        source: {
            type: String,
        },
        isComparisonModeOn: {
            type: Boolean,
            default: false,
        },
        editFields: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        segmentsAvailable() {
            if (this.adverseCard.data?.Enforcements 
            || this.adverseCard.data?.PEPs 
            || this.adverseCard.data?.SOEs
            || this.adverseCard.data?.AdverseMedias) {
                return true
            }
            else {
                return false
            }
        },

        additionalInformation() {
            let information = {
                "parent_id": "-",
                "master_id": this.adverseCard.Ent_ID,
                "category": this.adverseCard.EntryCategory.length>0 ? this.adverseCard.EntryCategory : "-",
                "subcategory": this.adverseCard.EntrySubCategory.length>0 ? this.adverseCard.EntrySubCategory: "-",
                "pep_exposure_level": this.adverseCard.EntLevel.length>0 ? this.adverseCard.EntLevel: "-",
                "pep_negative_news": this.adverseCard?.Watch == "0"? "No": "Yes",
                "relationships": this.adverseCard.Relations.length>0 ? "Yes": "No",
                "profile_notes": this.adverseCard.Remarks.length > 0 ? this.adverseCard.Remarks : "-"
            };

            if (information["relationships"] == "Yes") {
                information["parent_id"] =  this.adverseCard.Relations[0].Ent_ID
            }

            return information
        },

        // TODO component should be reworked to translate tab names
        segmentTabs() {
            let tabs = ["Enforcements", "SOE", "Adverse Media"]
            if (this.adverseCard?.data?.PEPs) {
                tabs = ["Enforcements", "Adverse Media", "PEP"]
            }
            if (this.adverseCard?.data?.OtherSegments) {
                tabs.push("Other Segments")
            }
            if (this.adverseCard?.data?.Sanctions) {
                tabs.push("Sanction")
            }
            return tabs
        },
        isMedia() {
            return this.adverseCard?.doc.media && this.adverseCard?.doc.media.length > 0;
        },
        adverseCardKey() {
            return this.expandedCard?.key;
        },

        profileData() {
            return get(this.adverseCard, "data.EntityDetails.AKAs", []).length > 0 || get(this.adverseCard, "data.EntityDetails.AdditionalInfo", []).length || get(this.adverseCard, "data.EntityDetails.IDs", []).length || get(this.adverseCard, "data.EntityDetails.Addresses", []).length;
        },

        screeningListData() {
            return this.adverseCard.NameSource
        },

        adverseCard: {
            get() {
                return this.expandedCard?.api_all_data ?? {};
            },
            set(val) {
                this.expandedCard.api_all_data = val;
            }
        },

        getProfileNotes: {
            get() {
                return this.adverseCard?.Remarks;
            },
            set(val) {
                this.adverseCard = {
                    ...this.adverseCard,
                    Remarks: val
                };
            }
        },

        sourceLinks: {
            get() {
                return this.adverseCard?.SourceWebLink
            },
            set(val) {
                this.adverseCard = {
                    ...this.adverseCard,
                    SourceWebLink: val
                };
            }
        },

        SourceWebLink() {
            return this.adverseCard?.SourceWebLink?.split(";")
        },
    },
    watch: {},
    mounted() {    
    },
    methods: {
        get,
        getAdditionalIden(data) {
            if (data == 'Category') {
                return "['data']['EntryCategory']"
            }
            if (data == 'Subcategory') {
                return "['data']['EntrySubCategory']"
            }
            if (data == 'PEP Exposure Level') {
                return "['data']['EntLevel']"
            }
            if (data == 'PEP Negative News') {
                return "['data']['Watch']"
            }
            if (data == 'Profile Notes') {
                return "['data']['Remarks']"
            }

        },
        getFormattedName(name) {

                if (name.split(",")[1] && name.split(",")[0]) {
                return name.split(",")[1] + " " + name.split(",")[0].trim()
                }
                else if (name.split(",")[1] && !name.split(",")[0]) {
                    return name.split(",")[1]
                }
                else if (!name.split(",")[1] && name.split(",")[0]) {
                    return name.split(",")[0]
                }
            
        },
        selectedInfo(info) {
            this.selected = info;
        },
        getFormattedDate(date) {
            if (date) {
                return date.split("-").reverse().join("-")
            }
            else return ''
        },
        getIdentifierMapping(key, index, listLength) {
            let mapping = "";
            if (key === "dateDetails")
                mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            else if (key === "countryDetails") {
                for (let i = 0; i < listLength; i++) mapping += ` ['data']['${this.source}']['CountryDetails'][${index}]['CountryValue'][${i}]['@name']`;
            } else if (key === "dates") {
                if (listLength >= 0)
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Year']`;
                else
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            } else if (key === "SanctionRefs") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['data']['@name'] ['data']['${this.source}']['SanctionsReferences'][${index}]['Value']['#text']`;
            else if (key === "SanctionRefsSince") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceYear']`;
            else if (key === "SanctionRefsTo") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@ToDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToYear']`;
            else if (key === "OtherSegments") {
                mapping = `['data']['OtherSegments'][${index}]['Source']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['OtherSegments'][${index}]['SubCategories'][${i}]`;
            } else if (key === "Enforcements") {
                mapping = `['data']['Enforcements'][${index}]['Source'] ['data']['Enforcements'][${index}]['Country'] `;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['Enforcements'][${index}]['SubCategories'][${i}]`;
            } else if (key === "PEPs") {
                mapping = `['data']['PEPs'][${index}]['Status'] 
                            ['data']['PEPs'][${index}]['IsPrimary']
                            ['data']['PEPs'][${index}]['Country'] 
                            ['data']['PEPs'][${index}]['AdminUnit']
                            ['data']['PEPs'][${index}]['AdminLevel'] 
                            ['data']['PEPs'][${index}]['CountryRole']
                            ['data']['PEPs'][${index}]['GoverningInstitution']
                            ['data']['PEPs'][${index}]['GoverningRole'] 
                            ['data']['PEPs'][${index}]['EffectiveDate']
                            ['data']['PEPs'][${index}]['ExpirationDate']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['PEPs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__SubCategories") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__Domain") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['Domain'][${i}]`;
            } else if (key === "AdverseMedias") {
                mapping = `['data']['AdverseMedias'][${index}]['Description']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['AdverseMedias'][${index}]['SubCategories'][${i}]`;
            }

            return mapping;
        },

        getCategory(category) {
            if (category === "None") return "AKA";
            else return category + " AKA";
        },

        getImages(adverseCard) {
            let img_arr = [];
            let img = adverseCard.Images;
            if (img) {
                if (Array.isArray(img)) {
                    img_arr = img;
                    // return img
                } else {
                    img_arr = img.Image;
                    // return img.Image
                }
            }
            return img_arr;
        },
        get_image_url(img) {
            if (img["@URL"] !== undefined) {
                return img["@URL"];
            } else {
                return "";
            }
        },
        async printPageLexis(id, name, print, noPrint) {
            this.printDone = false;
            this.isPrintLoader = true;
            await this.handleExpandAll(true);
            if (!print) {
                let htmlPDF = await this.printData(id, name, noPrint);
                this.$emit("updatePrintStatus", "");
                this.isPrintLoader = false;
                if (noPrint) {
                    return htmlPDF;
                }
            }
        },
        getAddress(address) {
            if (address) {
                if (Array.isArray(address)) return address;
                else {
                    let obj = [address];
                    return obj;
                }
            } else return [];
        },
        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },
    },
};
</script>


<style scoped>
.tabActions {
    display: tw-flex;
    overflow: hidden;
    overflow-x: auto;
}
/* .scroll-bar {
    height: 10px;
} */
.tabs {
    width: 100%;
    border-bottom: 3px solid var(--brand-accent-neutral);
    cursor: pointer;
    margin: 0.4rem 0;
    font-family: var(--brand-font);
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 10;
    display: tw-flex;
}
.tabContainer {
    width: 100%;
}

.tab {
    transform: translateY(3px);
    border-bottom: 3px solid transparent;
    transition: var(--transition-mnml);
    border-radius: var(--component-border) var(--component-border) 0 0;
    font-size: 16px;
    text-align: center;
    max-width: 100%;
    display: tw-flex;
    align-items: center;
    justify-content: center;
}
::-webkit-scrollbar {
    width: 10px;
    height: 12px;
}
::-webkit-scrollbar:vertical {
    background-color: gray; /* Blue thumb */
    border-radius: 10px;
    border: 2px solid #f1f1f1; 
}

::-webkit-scrollbar-track {
    background: white;
}

::-webkit-scrollbar-thumb {
    background-color: gray; /* Blue thumb */
    border-radius: 10px;
    border: 2px solid #f1f1f1; /* Optional border to make it stand out */
}
@media print {
    .rotate-180 {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
}
</style>
<style>
.cascading-highlighter {
    background-color: #f6f1bb;
}
@media print {
    .Vue-Toastification__container {
        display: none !important;
    }
    .print-hidden {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
    .relatives-close-associates {
        overflow-x: hidden !important;
    }
    .print-d-block {
        display: block !important;
    }
    table {
        page-break-inside: auto !important;
    }
    table tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table th {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr div {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr:before {
        min-height: 60px !important;
    }
    div {
        page-break-inside: auto !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
        box-sizing: content-box !important;
    }
    tr {
        page-break-inside: avoid !important;
    }
    table {
        table-layout: fixed !important;
    }
    /* table, */
    thead,
    /* tbody, */
    /* tr  */
    /* td, */
    th {
        display: block !important;
    }
    table thead tr {
        top: -9999px !important;
        left: -9999px !important;
        display: none !important;
    }

    table tr:nth-child(odd) {
        background: #f6f8fc !important;
    }
    table tr {
        /* border: none !important;
        border-bottom: 1px solid #eee !important;
        position: relative !important;
        align-items: center !important;
        display: tw-flex !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        padding: 5px 15px !important; */
        width: 100%;
    }
}
</style>
